import React from 'react';

interface ArrowProps {
  /**
   * The placement of the arrow relative to the popover.
   * Can be 'top', 'right', 'bottom', or 'left'.
   */
  placement: 'top' | 'right' | 'bottom' | 'left';
  /** Optional border color for the arrow.
   * Defaults to '#ccc'.
   */
  arrowBorderColor?: string;
}

const arrowSize = 12;
const arrowStyles: Record<string, React.CSSProperties> = {
  top: {
    position: 'absolute',
    left: '50%',
    bottom: -arrowSize,
    transform: 'translateX(-50%)  rotate(180deg)',
  },
  bottom: {
    position: 'absolute',
    left: '50%',
    top: -arrowSize / 2,
    transform: 'translateX(-50%) rotate(180deg)',
  },
  left: {
    position: 'absolute',
    right: -arrowSize,
    top: '50%',
    transform: 'translateY(-50%) rotate(180deg)',
  },
  right: {
    position: 'absolute',
    left: -arrowSize,
    top: '50%',
    transform: 'translateY(-50%) rotate(180deg)',
  },
}; /** Renders the arrow for the popover based on placement. */

/**
 * Renders the arrow for the popover based on placement.
 * @param param0 - The placement of the arrow and optional border color.
 * @returns JSX Element representing the arrow.
 */
export const PopoverArrow: React.FC<ArrowProps> = ({ placement, arrowBorderColor = '#ccc' }) => (
  <div
    style={{
      width: arrowSize,
      height: arrowSize,
      ...arrowStyles[placement],
      pointerEvents: 'none',
      zIndex: 0,
    }}
  >
    <svg width={arrowSize} height={arrowSize} viewBox={`0 0 ${arrowSize} ${arrowSize}`}>
      {placement === 'top' && (
        <>
          <polygon points={`0,${arrowSize} ${arrowSize / 2},0 ${arrowSize},${arrowSize}`} fill="#fff" />
          <polyline
            points={`0,${arrowSize} ${arrowSize / 2},0 ${arrowSize},${arrowSize}`}
            fill="none"
            stroke={arrowBorderColor}
            strokeWidth="1"
          />
        </>
      )}
      {placement === 'bottom' && (
        <>
          <polygon points={`0,0 ${arrowSize / 2},${arrowSize} ${arrowSize},0`} fill="#fff" />
          <polyline
            points={`0,0 ${arrowSize / 2},${arrowSize} ${arrowSize},0`}
            fill="none"
            stroke={arrowBorderColor}
            strokeWidth="1"
          />
        </>
      )}
      {placement === 'left' && (
        <>
          <polygon points={`${arrowSize},0 0,${arrowSize / 2} ${arrowSize},${arrowSize}`} fill="#fff" />
          <polyline
            points={`${arrowSize},0 0,${arrowSize / 2} ${arrowSize},${arrowSize}`}
            fill="none"
            stroke={arrowBorderColor}
            strokeWidth="1"
          />
        </>
      )}
      {placement === 'right' && (
        <>
          <polygon points={`0,0 ${arrowSize},${arrowSize / 2} 0,${arrowSize}`} fill="#fff" />
          <polyline
            points={`0,0 ${arrowSize},${arrowSize / 2} 0,${arrowSize}`}
            fill="none"
            stroke={arrowBorderColor}
            strokeWidth="1"
          />
        </>
      )}
    </svg>
  </div>
);
